import { render, staticRenderFns } from "./BusinessOrderPrescription.vue?vue&type=template&id=04613336"
import script from "./BusinessOrderPrescription.vue?vue&type=script&lang=js"
export * from "./BusinessOrderPrescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports